"use client";

import { Card, CardContent, CardHeader, cn } from "@saridana-core/react-ui-kit";
import { TProductHowToItem, TProductHowToSection } from "@shared/types";
import { SectionHeading } from "@shared/ui";
import Image from "next/image";

export function ProductHowToSection({ title, description, items, background }: TProductHowToSection) {
  return (
    <section className="py-20 md:py-[100px] lg:py-[120px] relative overflow-hidden">
      {background?.data?.attributes?.url && (
        <Image
          src={background?.data?.attributes?.url}
          height={background?.data?.attributes?.height}
          width={background?.data?.attributes?.width}
          alt={background?.data?.attributes?.alternativeText || background?.data?.attributes?.name || "Product Information Section"}
          className="hidden lg:block object-cover w-full h-auto bottom-0 right-0 absolute z-1"
        />
      )}

      <div className="container relative">
        <div className="flex gap-10 sm:gap-[60px] lg:gap-20 w-full flex-col lg:flex-row">
          <div className="lg:w-[45%] lg:min-w-[45%]">
            <SectionHeading title={title} className="max-w-full lg:max-w-[80%]" titleClassName="text-left mx-0" description={description} />
          </div>

          <div>{items && items?.length > 0 && <ProductHowToCards items={items} />}</div>
        </div>
      </div>
    </section>
  );
}

export function ProductHowToCards({ items }: { items: TProductHowToItem[] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {items?.map((item: TProductHowToItem, index: number) => (
        <Card
          key={`how-to-card-${index}`}
          className={cn(
            "rounded-3xl py-8 sm:py-10 px-6 sm:px-9 border-none shadow-none",
            item.color == "green" ? "bg-green-50" : "bg-primary-50",
          )}
        >
          <CardHeader className="p-0 mb-6 sm:mb-8">
            <div
              className={cn(
                "rounded-full flex items-center justify-center w-[52px] h-[52px]",
                item.color == "green" ? "bg-green-200" : "bg-primary-200",
              )}
            >
              <h3 className={cn("font-semibold text-xl", item.color == "green" ? "text-green-900" : "text-primary-900")}>{index + 1}</h3>
            </div>
          </CardHeader>

          <CardContent className="p-0">
            <h3 className="font-bold text-2xl sm:text-[28px] leading-[130%] mb-3 sm:mb-6">{item.title}</h3>
            <p className="text-lg sm:text-xl leading-[140%] text-gray-700">{item.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
